import { useEffect, useState } from "react";
import AdminLayout from "../components/AdminLayout";
import DataTable, { StatusPill, fmtDate } from "../components/DataTable";
import { apiCall } from "../auth/AuthContext";

const STATUS_TONE = (v) => {
  const s = (v || "").toLowerCase();
  if (s === "active") return "success";
  if (s === "onboarding") return "info";
  if (s === "paused" || s === "pending") return "warning";
  if (s === "churned" || s === "overdue") return "danger";
  return "neutral";
};

export default function AdminClients() {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      try { const d = await apiCall("/api/admin/clients"); setRecords(d.records || []); }
      catch { setRecords([]); }
      finally { setLoading(false); }
    })();
  }, []);

  const columns = [
    { key: "Client ID", label: "ID" },
    { key: "Full Name", label: "Name", sortable: true },
    { key: "Service Package", label: "Package" },
    { key: "Active Services", label: "Services", fmt: (v) => Array.isArray(v) ? v.join(", ") : (v || "—") },
    { key: "Client Status", label: "Status", fmt: (v) => <StatusPill value={v} tone={STATUS_TONE(v)} /> },
    { key: "Payment Status", label: "Payment", fmt: (v) => <StatusPill value={v} tone={STATUS_TONE(v)} /> },
    { key: "Date Joined", label: "Joined", fmt: fmtDate, sortable: true },
    { key: "Days as Client", label: "Days" },
    { key: "Next Appointment", label: "Next Apt", fmt: fmtDate },
    { key: "Consultant Assigned", label: "Consultant" },
  ];

  return (
    <AdminLayout title="CLIENT PORTFOLIO" kicker="All Clients">
      <DataTable
        testId="admin-clients-table"
        loading={loading}
        records={records}
        columns={columns}
        searchKeys={["Full Name", "Email", "Phone", "City State", "Client Status"]}
        emptyText="No clients yet — sign up your first one via /dashboard/signup."
      />
    </AdminLayout>
  );
}
